// Node's built-in fetch ignores https_proxy: undici only reads it when
// NODE_USE_ENV_PROXY=1 is set before the runtime starts, which a library cannot
// do for its caller. So resolve the proxy ourselves and pass an explicit
// dispatcher — the agent works behind a proxy without the caller knowing.
import { ProxyAgent, type Dispatcher } from "undici";

let cached: Dispatcher | null | undefined;

export function proxyUrl(): string | undefined {
  for (const name of ["https_proxy", "HTTPS_PROXY", "http_proxy", "HTTP_PROXY"]) {
    const value = (process.env[name] ?? "").trim();
    // socks5 (all_proxy) is deliberately ignored: ProxyAgent speaks HTTP CONNECT.
    if (value && /^https?:\/\//i.test(value)) return value;
  }
  return undefined;
}

export function dispatcher(): Dispatcher | undefined {
  if (cached === undefined) {
    const url = proxyUrl();
    cached = url ? new ProxyAgent(url) : null;
  }
  return cached ?? undefined;
}

/** fetch with the proxy applied and a timeout, since a hung video call stalls an episode. */
export async function post(url: string, body: unknown, timeoutMs = 180_000, headers: Record<string, string> = {}): Promise<Response> {
  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...headers },
    body: JSON.stringify(body),
    signal: AbortSignal.timeout(timeoutMs),
    ...(dispatcher() ? { dispatcher: dispatcher() } : {}),
  } as RequestInit);
}
